import { waitForAllReturnWhenError } from '@confluence/query-preloader-tools/entry-points/waitForAllReturnWhenError.ts';
import { query } from '@confluence/query-preloader-tools/entry-points/graphql.ts';

import { PersistenceQuery } from './SpaceViewsPersistenceQueries.graphql.ts';
import { SpaceRootQuery } from './SpaceViewsQueries.graphql.ts';

export function preloadSpaceViews(spaceKey: string, isLicensed: boolean) {
	const queries: Promise<any>[] = [];
	queries.push(
		query({
			/* @ts-expect-error -- http://go/cfe-use-relay-artifacts */
			query: SpaceRootQuery,
			variables: {
				spaceKey,
			},
		}),
	);

	if (isLicensed) {
		queries.push(
			query({
				/* @ts-expect-error -- http://go/cfe-use-relay-artifacts */
				query: PersistenceQuery,
				variables: {
					spaceKey,
				},
			}),
		);
	}
	return waitForAllReturnWhenError(queries);
}
